import { shallowRef } from '@vue/reactivity'
import { stopTracks } from '@browser'

class ScreensharingStream {
  constructor() {
    this.video = shallowRef()
    this.updatedAt = shallowRef(Date.now())
  }

  start = async () => {
    const constraints = {
      idealConstraints: {
        video: {
          width: {
            ideal: 1280,
          },
          height: {
            ideal: 720,
          },
          cursor: 'always',
        },
        audio: false,
      },
    }
    const stream = await navigator.mediaDevices.getDisplayMedia(constraints)
    this.video.value = stream
    this.updatedAt = Date.now()
    return stream
  }

  stop = () => {
    stopTracks(this.video.value)
      .then(() => {
        this.video.value = null
        this.updatedAt = null
      })
  }
}
const screensharingStream = new ScreensharingStream()
export { screensharingStream }
